import script from "./ListadoTrabajos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoTrabajos.vue?vue&type=script&setup=true&lang=js"

import "./ListadoTrabajos.vue?vue&type=style&index=0&id=00286329&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00286329"]])

export default __exports__